<template>

	<div>
		<v-system-bar color="grey lighten-4"></v-system-bar>
		<v-toolbar elevation="4" >
			<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

			<v-img class="mr-3 d-lg-block d-none" src="@/img/logo.png" max-width="50"></v-img><span class="d-md-block d-none">DragonPhoenix Catahoulas</span>
			<v-spacer></v-spacer>
			<v-btn class="ma-2 pa-1 d-sm-block d-none" outlined v-for="menu in menulist" :key="menu.name" :to="menu.link">
				<v-icon >{{ menu.icon }}</v-icon><span class="d-lg-block d-none">{{ menu.name }}</span>
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn icon><v-icon>mdi-magnify</v-icon></v-btn>
		</v-toolbar>

		<v-navigation-drawer v-model="drawer" absolute temporary>
			<v-list nav dense>
				<v-list-item-group>
					<v-list-item v-for="menu in menulist" :key="menu.name" :to="menu.link">
						<v-list-item-title><v-icon >{{ menu.icon }}</v-icon> {{ menu.name }}</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>

	</div>

</template>

<script>
export default {
	name: 'Menu',
	data() {
		return {
			drawer:false,
			group:'',
			menulist: [
				{name:'О породе', 		icon:'mdi-information-outline',							link:'/',},
				{name:'Наши кобели', 	icon:'mdi-gender-male',											link:'/dogs_m'},
				{name:'Наши суки', 		icon:'mdi-gender-female',										link:'/dogs_f'},
				{name:'Статьи', 			icon:'mdi-book-open-page-variant-outline',	link:'/documents'},
				{name:'Купить', 			icon:'mdi-cart-outline',										link:'/puppy'},
				{name:'Контакты', 		icon:'mdi-email-open-outline',							link:'/contacts'},
			],
		}
	}
}


		

</script>

<style>
#image {
	width: 40px;
}
</style>

